export const carousel = (selectorOrElement = '.c-carousel') => {
	const carouselElement =
		typeof selectorOrElement === 'string'
			? document.querySelector(selectorOrElement)
			: selectorOrElement

	if (!carouselElement) {
		return
	}

	const wrapper = carouselElement.querySelector('.swiper-wrapper')
	if (!wrapper) {
		return
	}

	const breakpoint = 1920
	let isCarouselMode = true
	let originalSlideCount = 0

	const duplicateSlides = () => {
		const slides = wrapper.querySelectorAll('.swiper-slide')
		const slidesArray = Array.from(slides)

		slidesArray.forEach((slide) => {
			const clone = slide.cloneNode(true)
			wrapper.appendChild(clone)
		})
	}

	const removeDuplicatedSlides = () => {
		if (originalSlideCount === 0) {
			return
		}

		const slides = wrapper.querySelectorAll('.swiper-slide')
		const slidesArray = Array.from(slides)

		if (slidesArray.length > originalSlideCount) {
			for (let i = originalSlideCount; i < slidesArray.length; i++) {
				slidesArray[i].remove()
			}
		}
	}

	const startCarousel = () => {
		const currentSlides = wrapper.querySelectorAll('.swiper-slide')
		if (currentSlides.length === originalSlideCount) {
			duplicateSlides()
		}
		wrapper.style.animation = 'carousel-scroll 60s linear infinite'
		carouselElement.classList.remove('c-carousel--static')
	}

	const stopCarousel = () => {
		wrapper.style.animation = 'none'
		wrapper.style.transform = 'translateX(0)'
		carouselElement.classList.add('c-carousel--static')
		removeDuplicatedSlides()
	}

	const handleResize = () => {
		const windowWidth = window.innerWidth
		const shouldBeCarousel = windowWidth < breakpoint

		if (shouldBeCarousel) {
			if (!isCarouselMode) {
				startCarousel()
				isCarouselMode = true
			} else if (
				!wrapper.style.animation ||
				wrapper.style.animation === 'none'
			) {
				startCarousel()
			}
		} else {
			if (isCarouselMode) {
				stopCarousel()
				isCarouselMode = false
			}
		}
	}

	const slides = wrapper.querySelectorAll('.swiper-slide')
	originalSlideCount = slides.length

	duplicateSlides()

	handleResize()

	window.addEventListener('resize', handleResize)
}
